var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStackoverflow = props => /*#__PURE__*/React.createElement("svg", _extends({
  stroke: "currentColor",
  fill: "currentColor",
  strokeWidth: 0,
  viewBox: "0 0 16 16",
  height: "1em",
  width: "1em",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M12.412 14.572V10.29h1.428V16H1v-5.71h1.428v4.282h9.984z",
  stroke: "none"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ff7300",
  d: "M3.857 13.145h7.137v-1.428H3.857v1.428zM10.254 0 9.108.852l4.26 5.727 1.146-.852L10.254 0zm-3.54 3.377 5.484 4.567.913-1.097L7.627 2.28l-.914 1.097zM4.922 6.55l6.47 3.013.603-1.294-6.47-3.013-.603 1.294zm-.925 3.344 6.985 1.469.294-1.398-6.985-1.468-.294 1.397z",
  stroke: "none"
})));
export { SvgStackoverflow as ReactComponent };
export default __webpack_public_path__ + "static/media/svg/stackoverflow.svg";